
import React from 'react';
import axios2 from 'services/axios2';

import {useParams} from 'react-router-dom';
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { NuDropdown } from 'components/nubox/NuDropdown';

import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";


import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
} from 'reactstrap';
import NuListSearch from 'components/nubox/NuListSearch';
import ModalMateriaDocente from './ModalMateriaDocente';

const data = [
  //{ id_medico: 1,  nombre: 'ALEX LIZARRAGA',  especialidad: '00000023',tel:''}, 
];
const data1 = [
  { value: 1, label: "Apple" },
  { value: 2, label: "Facebook" },
];
/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class MateriaDocenteList extends React.Component {  

  
  
  state = {
    modalInsertar: false,
    
        
    form: {
      name: 0,
    },
    data: data,/* lista de datos */

    carreras_arr: [],
    item_selected:{},
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
    this.modalRef = React.createRef();//create ref
  }
  //------------------
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de datos
    this.setState({data:[]});
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  //------------
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  //------------------------
  get_carreras = (key='') => {
    console.log("get_carreras")
    let param = { 
      key1: key
    }
    console.log(param);
    axios2.post( 'materia_docente_get_carreras', param)
    .then(res => {
    
        if(res.data.length>0){ 
            this.setState({carreras_arr: res.data});
        }else{
            NotificationManager.error('No existen datos');
        }

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });
  };
  //------------------------------
  // item es {value,label}
  onClickItemList =( item ) =>{
    console.log("onClickItemList")
    console.log(item)
    //---------cargamos el detalle en la otra tabla
    //---establecemos como item_selected
    this.setState({ item_selected: item});

    //-----------cargamos la tabla
    this.cargar_data(item)  //cargamos la lista de materias
  }
  //------------------------
  onClickItemBtn =( key ) =>{
    console.log("onClickItemBtn")
    console.log(key)
    //---------cargamos el detalle en la otra tabla
    this.get_carreras(key)  //en este caso el id_u del docente
    
  }
  //====================================================== 
  // item tiene value, label
  cargar_data = (item) => {
    console.log("cargar_data")
    console.log(item)
    let id_peri = this.props.store.user.id_peri;

    let param = { 
      id_carre: item.value,
      id_peri: id_peri,
    }
    console.log(param);
    axios2.post( 'materia_docente_get_list', param)
    .then(res => {
        console.log(res.data)
        console.log("length");
        console.log(res.data.length)
        if(res.data.length>0){ 
            this.setState({data: res.data});
        }else{
            this.setState({data: []});
            NotificationManager.error('No existen datos');
        }

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });

    //---establecemos como item_selected
    this.setState({ item_selected: item});
  };
  //======================================================     
  imprimir =(id_certi)=>{
    let fileURL = process.env.REACT_APP_API_URL  + 'certificado_reciboPDF/'+ id_certi;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  /* === This is where the magic happens ==== */
  handleSubmit = event => {
    event.preventDefault();
    this.cargar_data();
  }
  //-----------------------------------------------------------------
  //--esto es el asignar docente a materia
  nuevo = (item) => {
    console.log(this.state.item_selected)

    if(this.state.item_selected!==null){
      console.log(this.modalRef.current);

      //-----------sacamos datos del localStorage
      let id_peri = this.props.store.user.id_peri;
      let periodo = this.props.store.user.periodo;

      console.log("id_peri:" + id_peri, "periodo:" + periodo )
      this.modalRef.current.nuevo(item, id_peri, periodo);
    }else{
      console.log("elija una carrera")
    }
  }
  //-----------------------------------------------------------------
  editar = (item) =>{
    console.log('editar');
    console.log(item);
    let idd1 = item.id_doc_mat;

    //-----------sacamos datos del localStorage
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;

    this.modalRef.current.editar(idd1, id_peri, periodo);
  }
  //-----------------------------------------------------------------
  eliminar = (item) =>{
    console.log('eliminar');
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        let idd = item.id_doc_mat;
        this.modalRef.current.eliminar(idd);
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }
  //-------------------------------------
  okModal =()=>{
    console.log('citaOkModal');
    this.cargar_data(this.state.item_selected);
  }
  //-------------------------------------
  closeModal =()=>{
    console.log('citaCancelModal');
  }
  //------------------------------------
  //-------------------------------------
  render() {
  
    return (
      <div>
      
        { 
        
          //JSON.stringify( this.state )
        }
        <div className='content'>

          {/*{/*--- -----------------------------*/}
          <div className='row'>
            <div className='col-md-12'>
              <h3> Asignar materias a docente</h3>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-4'>
              <NuListSearch
                titulo='Carreras'
                value={ this.state.item_selected.value}
                options={this.state.carreras_arr}
                placeholder=''
                onClickBtn={ this.onClickItemBtn }
                onClickItem={ this.onClickItemList }
              />
            </div>
            {/** */}
            <div className='col-md-8'>
              <div className='top_title2'>
                <div className='row'>
                  <div className='col-md-12'>
                    
                  
                    <div className=' pull-right'>

                    </div>
                    <h4>Carrera: { this.state.item_selected.label }</h4>
                  </div>
                </div>
              </div>

              <table className='table table-striped table-hover' width='100%' align='center'>
                <thead>

                  <tr>
                    <th>Cod.Int.</th>
                    <th>Carrera</th>
                    <th>Sigla</th>
                    <th>Materia</th>
                    <th>Docente</th>
                    <th>Accion</th>
                  </tr>

                </thead>
                <tbody>
                  {/* className='text-left' */}
                  
                  {this.state.data.map((item, index) => (
                    <tr key={index}> 
                      <td>{ item.id_doc_mat}</td>
                      <td>{ item.carrera_nom}</td>
                      <td>{ item.sigla}</td>
                      <td>{ item.nombre}/G{item.id_grupo}</td>
                      <td>{ item.docente }
                      </td>

                      <td>
                        <div className='btn-group'>
                          { item.docente==="" &&
                            <Button className='btn btn-warning btn-sm' title='Asignar' 
                              onClick={() => this.nuevo(item)}>
                              <i className='fa fa-pencil'></i> Asignar
                            </Button>                         
                          }
                          &nbsp;
                          { item.docente!=="" &&
                            <Button className='btn btn-danger btn-sm' title='Revocar' 
                              onClick={() => this.eliminar(item)}  >
                              <i className='fa fa-trash'></i>Revocar
                            </Button>
                          }
                        </div>
                      </td>
                    </tr>
                  ))}



                </tbody>
              </table> 
            </div>
            {/** */}
            
          </div>


        
          
          {/*-- */}
          <div className="row">
             
          </div>
          {/*-- */}

          

        </div>
        <ModalMateriaDocente
              ref={this.modalRef}
              okModal={this.okModal}
              closeModal={this.closeModal}
            />
        <ToastContainer />
        <NuConfirm   ref={ this.refNuConfirm }    />
      </div>
      
    );
  }
}
//------------para que soporte la funcionalidad de parametros

export default withRouterJim (MateriaDocenteList);